import React from "react";
import abimg from "../../images/about.jpg"; // Replace with an image of Taisha
import { Link } from "react-router-dom";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const About2 = (props) => {
  return (
    <section className="wpo-about-section section-padding">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-12 col-12">
            <div className="wpo-about-wrap">
              <div className="wpo-about-img">
                <img src={abimg} alt="Taisha St. Jean Tard" />
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-12">
            <div className="wpo-about-text">
              <h4>About Taisha St. Jean Tard</h4>
              <h2>
                Championing the Rights and Needs of <b>Our Community</b>
              </h2>
              <p>
                Taisha St. Jean Tard has dedicated her life to advocating for
                the residents of Erie County’s 2nd District. With a proven track
                record in public service and community leadership, she strives
                to ensure that everyone has a voice in local government. From
                promoting transparency and accountability to creating
                opportunities for growth and development, Taisha is committed to
                making meaningful change that benefits all.
              </p>
              <Link onClick={ClickHandler} to="/about" className="theme-btn">
                More About Taisha
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About2;
